import React from 'react';
import { createRoot } from 'react-dom/client';

import GlobalStateProvider from 'containers/GlobalStateProvider';
import App from './app/app';
import configureSnowplow from 'tracking';

configureSnowplow();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <GlobalStateProvider>
    <App />
  </GlobalStateProvider>
);
